import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ChatJSONAModel } from "../interfaces/jsona-models/ChatJSONAModel";

export class ChatSelector extends BaseApiSelector<ChatJSONAModel> {
  constructor() {
    super(ResourceType.Chat);
  }
}
